<template>
  <Portal to="app-dialog">
    <VModal ref="modal" @modal:hidden="$emit('close')" disable-backdrop-click>
      <div class="w-full max-w-md mx-auto">
        <div class="mb-4">
          <div class="flex items-center justify-end">
            <div class="flex-none" @click.stop>
              <button
                class="h-10 w-10 inline-flex items-center justify-center bg-white hover:bg-gray-200 focus:outline-none rounded-full"
                @click="$refs.modal.close()"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
                  <path
                    d="M12 10.586l4.95-4.95 1.414 1.414-4.95
                      4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95
                      4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05
                      5.636z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="rounded shadow-xs w-full max-w-6xl mx-auto" @click.stop>
          <div class="rounded shadow-lg bg-white overflow-hidden">
            <div class="px-4 sm:px-6 py-5 border-b">
              <div class="flex items-center justify-between">
                <div class="flex-1">
                  <h1 class="text-sm">Change pipeline stage color</h1>
                </div>
              </div>
            </div>
            <template>
              <div class="p-4 sm:p-6 space-y-8">
                <ul class="flex flex-wrap">
                  <li v-for="(backgroundColor, idx) in colors" :key="idx" class="p-1">
                    <button
                      type="button"
                      class="w-8 h-8 rounded-full focus:outline-none"
                      :class="backgroundColor === pipelineStage.color && 'ring-2 ring-black'"
                      :style="{ backgroundColor }"
                      @click="setColor(backgroundColor)"
                    />
                  </li>
                </ul>
              </div>
            </template>
          </div>
        </div>
      </div>
    </VModal>
  </Portal>
</template>

<script>
import colors from './colors';

const props = {
  pipelineStage: {
    type: Object,
    required: true,
  },
};

function data() {
  return {
    colors,
  };
}

const methods = {
  setColor(color) {
    this.$emit('update', { color });
  },
};

export default {
  props,
  data,
  methods,
};
</script>
